export default function DocumentNotice() {
  return (
    <section className="w-full py-14" style={{ backgroundColor: '#f4faf8' }}>
      <div className="max-w-5xl mx-auto px-6 space-y-8">

        {/* 전체 서류 요약 배너 */}
        <div
          className="rounded-2xl p-6 md:p-8"
          style={{ background: 'linear-gradient(135deg, #0d2b24 0%, #1a4a3a 100%)' }}
        >
          <div className="flex items-center gap-3 mb-6">
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ backgroundColor: 'rgba(111,207,184,0.2)' }}
            >
              <i className="ri-file-list-3-line text-xl" style={{ color: '#6fcfb8' }} />
            </div>
            <div>
              <p className="text-xs font-bold tracking-widest uppercase" style={{ color: '#6fcfb8' }}>DOCUMENT FLOW</p>
              <h3 className="text-base font-bold text-white">전체 서류 흐름 요약</h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* 환자 → 회사 */}
            <div
              className="rounded-xl p-5"
              style={{ backgroundColor: 'rgba(255,255,255,0.07)' }}
            >
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-user-heart-line text-sm" style={{ color: '#6fcfb8' }} />
                <p className="text-xs font-bold" style={{ color: '#6fcfb8' }}>
                  환자 → 회사 제출서류
                </p>
                <span className="ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: 'rgba(111,207,184,0.2)', color: '#6fcfb8' }}>4종</span>
              </div>
              <ul className="space-y-2">
                {[
                  '간호기록지 (병원 발급)',
                  '입·퇴원 확인서 (병원 발급)',
                  '간병일지 (회사 양식)',
                  '이체확인증 (직접 캡쳐)',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-2 text-xs" style={{ color: 'rgba(255,255,255,0.8)' }}>
                    <span
                      className="w-4 h-4 flex items-center justify-center rounded-full text-[10px] font-black flex-shrink-0"
                      style={{ backgroundColor: 'rgba(111,207,184,0.25)', color: '#6fcfb8' }}
                    >
                      {i + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-[10px] mt-3 leading-relaxed" style={{ color: 'rgba(255,255,255,0.45)' }}>
                카카오 채팅방 또는 팩스(070-7862-8654)로 전송
              </p>
            </div>

            {/* 회사 → 환자 → 보험사 */}
            <div
              className="rounded-xl p-5"
              style={{ backgroundColor: 'rgba(255,255,255,0.07)' }}
            >
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-building-2-line text-sm" style={{ color: '#6fcfb8' }} />
                <p className="text-xs font-bold" style={{ color: '#6fcfb8' }}>
                  회사 → 환자 발급서류
                </p>
                <span className="ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: 'rgba(111,207,184,0.2)', color: '#6fcfb8' }}>3종</span>
              </div>
              <ul className="space-y-2">
                {[
                  '이용내역 확인서',
                  '회원가입 사실확인서',
                  '사업자등록증',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-2 text-xs" style={{ color: 'rgba(255,255,255,0.8)' }}>
                    <span
                      className="w-4 h-4 flex items-center justify-center rounded-full text-[10px] font-black flex-shrink-0"
                      style={{ backgroundColor: 'rgba(111,207,184,0.25)', color: '#6fcfb8' }}
                    >
                      {i + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-[10px] mt-3 leading-relaxed" style={{ color: 'rgba(255,255,255,0.45)' }}>
                환자가 4종 제출 후 발급 · 전체 서류를 보험사에 청구
              </p>
            </div>
          </div>
        </div>

        {/* 간병일지 다운로드 */}
        <div
          className="rounded-2xl p-6 border"
          style={{ backgroundColor: '#fff', borderColor: 'rgba(46,125,107,0.2)' }}
        >
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-download-2-line text-base" style={{ color: '#2E7D6B' }} />
            <h4 className="text-sm font-bold text-gray-900">간병일지 양식 다운로드</h4>
          </div>
          <p className="text-xs text-gray-500 leading-relaxed mb-5">
            간병인은 코리아케어러스 공식 양식으로{' '}
            <strong className="text-gray-700">매일 간병일지를 작성</strong>해야 합니다. 보험사별 양식이 상이할 수 있으니 당사로 문의 부탁드립니다.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/5c697202-8ad9-4e34-ac08-218afddde98f_-_.jpg?v=070242f12d6341e7692f61bf2fab374f"
              download="간병일지_코리아케어러스.jpg"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-image-line" />간병일지 양식 (JPG) 다운로드
            </a>
            <a
              href="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/4c16399f-393b-4b34-8cba-ab9c90f2097a_-_.pdf?v=39a1b7db47ac57a7935e46154017abc8"
              download="간병일지_코리아케어러스.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#f0f9f6', color: '#2E7D6B', border: '1px solid #2E7D6B' }}
            >
              <i className="ri-file-pdf-line" />간병일지 양식 (PDF) 다운로드
            </a>
          </div>
        </div>

        {/* 고객센터 + CTA */}
        <div
          className="rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-5"
          style={{ backgroundColor: '#f0f9f6', border: '1px solid rgba(46,125,107,0.2)' }}
        >
          <div
            className="w-12 h-12 flex items-center justify-center rounded-2xl flex-shrink-0"
            style={{ backgroundColor: 'rgba(46,125,107,0.12)' }}
          >
            <i className="ri-customer-service-2-line text-2xl" style={{ color: '#2E7D6B' }} />
          </div>
          <div className="flex-1">
            <p className="text-xs font-semibold text-gray-500 mb-0.5">코리아케어러스 고객센터</p>
            <a
              href="tel:15668654"
              className="text-2xl font-black block cursor-pointer hover:opacity-80 transition-opacity"
              style={{ color: '#2E7D6B' }}
            >
              1566-8654
            </a>
            <p className="text-xs text-gray-400 mt-0.5">오전 9시 ~ 오후 11시 · 연중무휴</p>
          </div>
          <div className="flex flex-col gap-2 flex-shrink-0">
            <a
              href="/register"
              className="px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity text-center"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-user-add-line mr-1.5" />가족간병 등록하기
            </a>
            <a
              href="/process"
              className="px-5 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity text-center"
              style={{ backgroundColor: '#f0f9f6', color: '#2E7D6B', border: '1px solid #2E7D6B' }}
            >
              <i className="ri-file-list-3-line mr-1.5" />청구절차 보기
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}